exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.noheader .card-header[data-v-5183c938]{\n    display: none;\n}\n", ""]);

